/* restyle layer: herb bars open one at a time (Hana's paragraph sits behind the tap) */
document.querySelectorAll('.rs-bar button').forEach(function(b){
  b.addEventListener('click',function(){
    var bar=b.parentNode,was=bar.classList.contains('open');
    if(was&&window.matchMedia('(min-width:1000px)').matches)return; /* desktop: one herb is always open, so the band never changes height */
    document.querySelectorAll('.rs-bar.open').forEach(function(o){o.classList.remove('open');o.querySelector('button').setAttribute('aria-expanded','false')});
    if(!was){bar.classList.add('open');b.setAttribute('aria-expanded','true')}
    var panel=bar.closest('.rs-herbs').querySelector('.rs-herbpanel');
    if(panel){if(was){panel.hidden=true}else{panel.querySelector('h3').textContent=b.querySelector('h3').textContent;panel.querySelector('p').innerHTML=bar.querySelector('.rs-more p').innerHTML;panel.hidden=false}}
  });
});
/* desktop: first herb open on load so the panel is never empty */
if(window.matchMedia('(min-width:1000px)').matches){var f=document.querySelector('.rs-bar button');if(f)f.click()}

/* desktop: step paragraphs open from their lead line */
document.querySelectorAll('.rs-morebtn').forEach(function(b){b.addEventListener('click',function(){var st=b.parentNode,o=st.classList.toggle('open');b.setAttribute('aria-expanded',o);b.textContent=o?'Show less':'Read more'})});
